require('./angular-notify');
module.exports = 'cgNotify';